<ng-container *transloco="let t">
	<eventlyte-registration-stepper-progress
		[currentStep]="AppRoutePaths.RegistrationMatching"
		[steps]="getSteps()"
		[maxStepReached]="maxStepReached" />

	<p class="title is-4 pb-1 mb-1">{{ t('content.steps.matchingTitle') }}</p>

	<div class="content">
		<p>{{ t('content.pages.matching.instructions') }}</p>
	</div>

	<div class="mb-5">
		<eventlyte-tag-list-field
			formKey="bgovBmHopingToAchieve"
			[formGroup]="formGroup"
			[label]="t('fields.bgovBmHopingToAchieve.label')"
				[value]="getRecordValue(record, 'bgovBmHopingToAchieve')"
			(valueChange)="setRecordValue(record, 'bgovBmHopingToAchieve', $event)"
			[editing]="true"
			[deselectable]="false"
		>
			<eventlyte-tag-field
				value="Find and evaluate AI solutions to deploy or pilot in my organisation"
				[label]="t('fields.bgovBmHopingToAchieve.options.Find and evaluate AI solutions to deploy or pilot in my organisation')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Generate sales leads and new client relationships"
				[label]="t('fields.bgovBmHopingToAchieve.options.Generate sales leads and new client relationships')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Find strategic partners, distributors or channel partners"
				[label]="t('fields.bgovBmHopingToAchieve.options.Find strategic partners, distributors or channel partners')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Get real-world feedback on my product or solution"
				[label]="t('fields.bgovBmHopingToAchieve.options.Get real-world feedback on my product or solution')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Meet investors and explore funding opportunities"
				[label]="t('fields.bgovBmHopingToAchieve.options.Meet investors and explore funding opportunities')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Scout for innovative startups or technologies for corporate adoption"
				[label]="t('fields.bgovBmHopingToAchieve.options.Scout for innovative startups or technologies for corporate adoption')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Learn about AI trends and build knowledge"
				[label]="t('fields.bgovBmHopingToAchieve.options.Learn about AI trends and build knowledge')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Expand into GBA or overseas markets"
				[label]="t('fields.bgovBmHopingToAchieve.options.Expand into GBA or overseas markets')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Network with peers and industry leaders"
				[label]="t('fields.bgovBmHopingToAchieve.options.Network with peers and industry leaders')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Recruit talent or find collaborators"
				[label]="t('fields.bgovBmHopingToAchieve.options.Recruit talent or find collaborators')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
		</eventlyte-tag-list-field>

	</div>

	<div class="mb-5">
		<eventlyte-tag-list-field
			formKey="bgovBmCurrentStageOfProduct"
			[formGroup]="formGroup"
			[label]="t('fields.bgovBmCurrentStageOfProduct.label')"
				[value]="getRecordValue(record, 'bgovBmCurrentStageOfProduct')"
			(valueChange)="setRecordValue(record, 'bgovBmCurrentStageOfProduct', $event)"
			[editing]="true"
			[deselectable]="false"
		>
			<eventlyte-tag-field
				value="Conceptual / pre-prototype (idea stage)"
				[label]="t('fields.bgovBmCurrentStageOfProduct.options.Conceptual / pre-prototype (idea stage)')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Prototype / MVP (working demo, no commercial clients yet)"
				[label]="t('fields.bgovBmCurrentStageOfProduct.options.Prototype / MVP (working demo, no commercial clients yet)')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Early commercial (1–5 paying clients or pilots)"
				[label]="t('fields.bgovBmCurrentStageOfProduct.options.Early commercial (1–5 paying clients or pilots)')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Growth stage (scaling, 6+ clients, proven business model)"
				[label]="t('fields.bgovBmCurrentStageOfProduct.options.Growth stage (scaling, 6+ clients, proven business model)')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Mature / established (market leader or significant market share)"
				[label]="t('fields.bgovBmCurrentStageOfProduct.options.Mature / established (market leader or significant market share)')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Not Applicable (N/A)"
				[label]="t('fields.bgovBmCurrentStageOfProduct.options.Not Applicable (N/A)')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
		</eventlyte-tag-list-field>

	</div>

	<div class="mb-5">
		<eventlyte-tag-list-field
			formKey="bgovBmOrganisationsCurrentAiAdoptionStage"
			[formGroup]="formGroup"
			[label]="t('fields.bgovBmOrganisationsCurrentAiAdoptionStage.label')"
				[value]="getRecordValue(record, 'bgovBmOrganisationsCurrentAiAdoptionStage')"
			(valueChange)="setRecordValue(record, 'bgovBmOrganisationsCurrentAiAdoptionStage', $event)"
			[editing]="true"
			[deselectable]="false"
		>
			<eventlyte-tag-field
				value="Exploring / researching for the first time"
				[label]="t('fields.bgovBmOrganisationsCurrentAiAdoptionStage.options.Exploring / researching for the first time')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Have identified use cases, building a business case"
				[label]="t('fields.bgovBmOrganisationsCurrentAiAdoptionStage.options.Have identified use cases, building a business case')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Running 1–2 AI pilots"
				[label]="t('fields.bgovBmOrganisationsCurrentAiAdoptionStage.options.Running 1–2 AI pilots')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Actively scaling AI across the organisation"
				[label]="t('fields.bgovBmOrganisationsCurrentAiAdoptionStage.options.Actively scaling AI across the organisation')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="AI is already core to our daily operations"
				[label]="t('fields.bgovBmOrganisationsCurrentAiAdoptionStage.options.AI is already core to our daily operations')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Not Applicable (N/A)"
				[label]="t('fields.bgovBmOrganisationsCurrentAiAdoptionStage.options.Not Applicable (N/A)')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
		</eventlyte-tag-list-field>

	</div>

	<div class="mb-5">
		<eventlyte-tag-list-field
			formKey="bgovBmTechnologiesInterested"
			[formGroup]="formGroup"
			[label]="t('fields.bgovBmTechnologiesInterested.label')"
				[value]="getRecordValue(record, 'bgovBmTechnologiesInterested')"
			(valueChange)="setRecordValue(record, 'bgovBmTechnologiesInterested', $event)"
			[editing]="true"
			[multipleSelection]="true"
			[maximumSelectable]="3"
			[deselectable]="false"
		>
			<eventlyte-tag-field
				value="Generative AI / LLM / Copilot productivity tools"
				[label]="t('fields.bgovBmTechnologiesInterested.options.Generative AI / LLM / Copilot productivity tools')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="AI agents and workflow automation / RPA case"
				[label]="t('fields.bgovBmTechnologiesInterested.options.AI agents and workflow automation / RPA case')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Robotics and embodied AI (service, industrial, medical)"
				[label]="t('fields.bgovBmTechnologiesInterested.options.Robotics and embodied AI (service, industrial, medical)')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Drones and low-altitude economy solutions"
				[label]="t('fields.bgovBmTechnologiesInterested.options.Drones and low-altitude economy solutions')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="AI for customer service and experience"
				[label]="t('fields.bgovBmTechnologiesInterested.options.AI for customer service and experience')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="AI for finance, accounting and compliance"
				[label]="t('fields.bgovBmTechnologiesInterested.options.AI for finance, accounting and compliance')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="AI for HR, talent and people management"
				[label]="t('fields.bgovBmTechnologiesInterested.options.AI for HR, talent and people management')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="AI for logistics, supply chain and warehousing"
				[label]="t('fields.bgovBmTechnologiesInterested.options.AI for logistics, supply chain and warehousing')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="AI for healthcare and clinical applications"
				[label]="t('fields.bgovBmTechnologiesInterested.options.AI for healthcare and clinical applications')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="AI for construction, property and smart buildings"
				[label]="t('fields.bgovBmTechnologiesInterested.options.AI for construction, property and smart buildings')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="AI for retail and e-commerce personalisation"
				[label]="t('fields.bgovBmTechnologiesInterested.options.AI for retail and e-commerce personalisation')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="AI for smart city and public services"
				[label]="t('fields.bgovBmTechnologiesInterested.options.AI for smart city and public services')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Data analytics and business intelligence"
				[label]="t('fields.bgovBmTechnologiesInterested.options.Data analytics and business intelligence')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="AI security, governance and responsible AI"
				[label]="t('fields.bgovBmTechnologiesInterested.options.AI security, governance and responsible AI')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="AI training, upskilling and change management"
				[label]="t('fields.bgovBmTechnologiesInterested.options.AI training, upskilling and change management')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
		</eventlyte-tag-list-field>

	</div>

	<div class="mb-5">
		<eventlyte-tag-list-field
			formKey="bgovBmBudgetAllocation"
			[formGroup]="formGroup"
			[label]="t('fields.bgovBmBudgetAllocation.label')"
				[value]="getRecordValue(record, 'bgovBmBudgetAllocation')"
			(valueChange)="setRecordValue(record, 'bgovBmBudgetAllocation', $event)"
			[editing]="true"
			[deselectable]="false"
		>
			<eventlyte-tag-field
				value="Yes, budget is approved and I am ready to procure / pilot"
				[label]="t('fields.bgovBmBudgetAllocation.options.Yes, budget is approved and I am ready to procure / pilot')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Budget is under internal review or approval"
				[label]="t('fields.bgovBmBudgetAllocation.options.Budget is under internal review or approval')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="I am building a business case and need to evaluate options first"
				[label]="t('fields.bgovBmBudgetAllocation.options.I am building a business case and need to evaluate options first')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="No budget yet; early exploration stage"
				[label]="t('fields.bgovBmBudgetAllocation.options.No budget yet; early exploration stage')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="I represent a government / funded body with procurement authority"
				[label]="t('fields.bgovBmBudgetAllocation.options.I represent a government / funded body with procurement authority')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
		</eventlyte-tag-list-field>

	</div>
	<div class="mb-5">
		<eventlyte-tag-list-field
			formKey="bgovBmCurrentBusinessChallenges"
			[formGroup]="formGroup"
			[label]="t('fields.bgovBmCurrentBusinessChallenges.label')"
				[value]="getRecordValue(record, 'bgovBmCurrentBusinessChallenges')"
			(valueChange)="setRecordValue(record, 'bgovBmCurrentBusinessChallenges', $event)"
			[editing]="true"
			[multipleSelection]="true"
			[maximumSelectable]="3"
			[deselectable]="false"
		>
			<eventlyte-tag-field
				value="Lowering cost and improve efficiency"
				[label]="t('fields.bgovBmCurrentBusinessChallenges.options.Lowering cost and improve efficiency')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Customer and revenue growth"
				[label]="t('fields.bgovBmCurrentBusinessChallenges.options.Customer and revenue growth')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Data and decision-making"
				[label]="t('fields.bgovBmCurrentBusinessChallenges.options.Data and decision-making')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="People and talent"
				[label]="t('fields.bgovBmCurrentBusinessChallenges.options.People and talent')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Innovation and product development"
				[label]="t('fields.bgovBmCurrentBusinessChallenges.options.Innovation and product development')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Compliance and risk"
				[label]="t('fields.bgovBmCurrentBusinessChallenges.options.Compliance and risk')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Infrastructure and technology"
				[label]="t('fields.bgovBmCurrentBusinessChallenges.options.Infrastructure and technology')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
		</eventlyte-tag-list-field>

	</div>
	<div class="mb-5">
		<eventlyte-tag-list-field
			formKey="bgovBmBusinessObjectives"
			[formGroup]="formGroup"
			[label]="t('fields.bgovBmBusinessObjectives.label')"
				[value]="getRecordValue(record, 'bgovBmBusinessObjectives')"
			(valueChange)="setRecordValue(record, 'bgovBmBusinessObjectives', $event)"
			[editing]="true"
			[multipleSelection]="true"
			[maximumSelectable]="10000"
			[deselectable]="false"
		>
			<eventlyte-tag-field
				value="Hong Kong (primary market)"
				[label]="t('fields.bgovBmBusinessObjectives.options.Hong Kong (primary market)')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Greater Bay Area"
				[label]="t('fields.bgovBmBusinessObjectives.options.Greater Bay Area')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Mainland China (beyond GBA)"
				[label]="t('fields.bgovBmBusinessObjectives.options.Mainland China (beyond GBA)')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Taiwan Region"
				[label]="t('fields.bgovBmBusinessObjectives.options.Taiwan Region')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Southeast Asia–Singapore / Malaysia / Thailand / Philippines / Vietnam"
				[label]="t('fields.bgovBmBusinessObjectives.options.Southeast Asia–Singapore / Malaysia / Thailand / Philippines / Vietnam')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Japan"
				[label]="t('fields.bgovBmBusinessObjectives.options.Japan')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="South Korea"
				[label]="t('fields.bgovBmBusinessObjectives.options.South Korea')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Europe"
				[label]="t('fields.bgovBmBusinessObjectives.options.Europe')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Middle East"
				[label]="t('fields.bgovBmBusinessObjectives.options.Middle East')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="North / South Americas"
				[label]="t('fields.bgovBmBusinessObjectives.options.North / South Americas')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="No specific focus"
				[label]="t('fields.bgovBmBusinessObjectives.options.No specific focus')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
		</eventlyte-tag-list-field>

	</div>
	<div class="mb-5">
		<eventlyte-text-field
			formKey="bgovQuestionOrProblem"
			[formGroup]="formGroup"
			[label]="t('fields.bgovQuestionOrProblem.label')"
				[editing]="true"
			[multiline]="true"
			[value]="getRecordValue(record, 'bgovQuestionOrProblem')"
			(valueChange)="setRecordValue(record, 'bgovQuestionOrProblem', $event)" />

	</div>

	<eventlyte-registration-stepper-controls
		[currentStep]="AppRoutePaths.RegistrationMatching"
		[steps]="getSteps()"
		(startAgain)="startAgain()"
		(submitClick)="continue()"
		[processing]="saving()" />

	@if (showFormErrors()) {
		<eventlyte-registration-form-errors-modal
			[(active)]="showFormErrors"
			[formGroups]="validationFormGroups!" />
	}

	@if (showServerErrors()) {
		<eventlyte-registration-server-errors-modal
			[(active)]="showServerErrors"
			[errorList]="serverErrorList()" />
	}
</ng-container>
